<template>
  <div class="login-page">

    <div class="login-l">
      <img src="@/assets/logo.png" class="logo"/>
      <img src="@/assets/login_bg.jpg" class="login-bg"/>
    </div>

    <div class="login-r">
      <div class="lang-box">
        <el-dropdown trigger="click" @command="handleChangeLang">
          <div class="lang-row">
            <img class="lang-icon" src="@/assets/icon/lang_icon.png"/>
            <span>{{ $t('lang.语言') }}</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="i" v-for="i in langInfo" :key="i.lang">{{ i.name }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>

      <div class="form-box">

        <div class="title">
          <span>{{ $t('lang.登录') }}</span>
          <span>· {{ $t('lang.品牌端') }}</span>
        </div>

        <div class="operate-row" @click="handleSetPassword('login')">
          <span>{{ $t('lang.首次登录') }}？</span>
          <span>{{ $t('lang.免费注册') }}</span>
        </div>

        <el-form :model="formData" :rules="rules" ref="form" @keyup.enter.native="login">
          <el-form-item prop="account">
            <el-input v-model="formData.account" :placeholder="$t('lang.请输入账号')">
              <template slot="prefix">
                <div class="form-icon-row">
                  <img src="@/assets/icon/user.png" class="form-icon"/>
                </div>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input v-model="formData.password" :placeholder="$t('lang.请输入密码')" type="password">
              <template slot="prefix">
                <div class="form-icon-row">
                  <img src="@/assets/icon/lock.png" class="form-icon"/>
                </div>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item class="input-group" prop="captcha">
            <el-input v-model="formData.captcha" class="verify-input" :placeholder="$t('lang.请输入验证码')">
              <template slot="prefix">
                <div class="form-icon-row">
                  <img src="@/assets/icon/auth_icon.png" class="form-icon"/>
                </div>
              </template>
            </el-input>
            <img class="verify-img" @click="handleGetCaptcha" :src="verifyCode"
                 alt="">
          </el-form-item>

          <el-form-item>
            <div class="password-row">
              <el-checkbox v-model="rememberMe">{{ $t('lang.记住密码') }}</el-checkbox>
              <span class="forget-text" @click="handleSetPassword('forget')">{{ $t('lang.忘记密码') }}？</span>
            </div>
          </el-form-item>

          <el-button @click.native="login">{{ $t('lang.登录') }}</el-button>

        </el-form>


      </div>
    </div>

  </div>
</template>

<script>
import {
  loadBrandOwnerProduct,
  loadBrandProductTree,
  loadCountry, loadDict,
  loadProduct, loadSubBrand, loadSysSettLang,
  loadSysSupportLang,
  saveUserInfo
} from "../js/common";

export default {
  name: "NewLogin",
  data() {
    return {
      langInfo: [
        {lang: 'zh', name: '简体中文'},
        {lang: 'en', name: 'English'},
      ],
      formData: {
        account: '',
        password: '',
        captcha: ''
      },
      rememberMe: false,
      isBtnLoading: false,
      verifyCode: ''
    }
  },
  computed: {
    rules() {
      return {
        account: [
          {required: true, message: this.$t('lang.用户名不能为空'), trigger: 'blur'},
        ],
        password: [
          {required: true, message: this.$t('lang.密码不能为空'), trigger: 'blur'},
        ],
        captcha: [
          {required: true, message: this.$t('lang.验证码不能为空'), trigger: 'blur'},
        ]
      }
    }
  },
  methods: {
    handleChangeLang(lang) {
      this.$i18n.locale = lang.lang;
    },

    handleGetCaptcha() {
      this.$http.get(this.$api.login.captcha, {responseType: "arraybuffer"}).then(res => {
        if (res.status == 200) {
          const img = btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ""));
          this.verifyCode = "data:image/png;base64," + img;
        }
      })
    },

    // 跳转设置密码
    handleSetPassword(flag) {
      this.$router.push({path: '/set-password', query: {flag}});
    },

    async login() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const data = {...this.formData, sysFlag: 'brand'};
          data['password'] = this.$md5(data['password']);
          this.$http(this.$api.login.login, {
            method: "POST",
            data,
            headers: {
              'content-type': 'multipart/form-data',
            }
          }).then(res => {
            if (res.data.status != 200) {
              this.$message.error(res.data.desc);
              return;
            }

            if (this.rememberMe) {
              const {account, password} = this.formData
              let data = JSON.stringify({account, password});
              window.localStorage.setItem('accountInfo', data);
            } else if (!this.rememberMe && window.localStorage.getItem('accountInfo')) {
              window.localStorage.removeItem('accountInfo');
            }

            if (Object.keys(res.data.data.user).length) {
              window.sessionStorage.setItem('login-user-info', JSON.stringify(res.data.data.user));
              saveUserInfo(this);
              loadCountry(this);
              loadProduct(this);
              loadSysSupportLang(this);
              loadBrandProductTree(this);
              loadSysSettLang(this);
              loadSubBrand(this, res.data.data.user.brandOwnerCode);
              loadDict(this, 'INGREDIENTS_UNIT', 'ADD_RECIPE_UNIT')
              loadDict(this, 'HOT_WIND_MODE', 'ADD_HOST_WIND_MODE')
              loadBrandOwnerProduct(this, this.$store.state.userInfo.brandOwnerCode, true);
              this.$store.dispatch('LOAD_DEV_MODES');
            }

            this.$router.push('/')

          }).catch(err => {
            console.log("登录失败", err);
          })
        }
      });
    }
  },
  created() {
    this.handleGetCaptcha();
    let accountInfo = window.localStorage.getItem('accountInfo');
    if (accountInfo) {
      accountInfo = JSON.parse(accountInfo);
      this.formData = accountInfo;
      this.rememberMe = true;
    }
  }
}
</script>

<style scoped>

.login-page {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
}

.login-l {
  width: calc(100vw - 540px);
  height: 100%;
}

.logo {
  width: 254px;
  height: 28px;
  position: absolute;
  left: 30px;
  top: 30px;
}

.login-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.login-r {
  width: 540px;
  height: 100%;
  background: #FFFAF4;
  box-shadow: 0px 6px 30px 0px rgba(0, 0, 0, 0.1);
  /*border-radius: 36px 0px 0px 36px;*/
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.lang-box {
  position: absolute;
  right: 40px;
  top: 40px;
  cursor: pointer;
}

.lang-row {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #666666;
}

.lang-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}

.form-box {
  width: 336px;
}

.title {
  font-size: 32px;
  color: #333333;
}

.title span:first-child {
  margin-right: 14px;
}

.operate-row {
  font-size: 14px;
  color: #333333;
  margin: 14px 0 40px;
  cursor: pointer;
}

.operate-row span:last-child {
  color: #ED7700;
}

.form-icon-row {
  height: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  margin-left: 2px;
}

.form-icon {
  width: 16px;
  height: 16px;
}


.input-group {
  display: flex;
  align-items: center;
  width: 100%;
}

/deep/ .input-group .el-form-item__content {
  display: flex;
}

.verify-input {
  width: 202px;
  margin-right: 8px;
}

.verify-img {
  width: 126px;
  height: 40px;
}

.password-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.forget-text {
  font-size: 14px;
  color: #ED7700;
  cursor: pointer;
}

.el-button {
  width: 100%;
  color: #FFFFFF;
  font-size: 16px;
  background: #ED7700;
}

.el-button:focus, .el-button:hover {
  color: #ED7700;
  border-color: rgba(237, 119, 0, .5);
  background-color: rgba(237, 119, 0, .2);
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #ED7700;
  border-color: #ED7700;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #666666;
}

/deep/ .el-input.is-active .el-input__inner, .el-input__inne {
  border-color: #ED7700 !important;
}

</style>
